#import "../fragments/lead-personal-email-sequences-fragment.graphql"

query GetLeadPersonalEmailSequences($leadId: ID!) {
    lead(id: $leadId) {
        ...LeadPersonalEmailSequencesFragment
    }
}
